// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as jsxRuntime from "react/jsx-runtime";
import { IconSwords } from "./icons.jsx";
import { IconCrown } from "@tabler/icons-react";
import "./AppNavigation.css";
import { HalloweenAccents } from "./HalloweenAccents.jsx";
export const sb = "_navigation_xv4b5_1";
export const ib = "_item_xv4b5_46";
export const cb = "_icon_xv4b5_66";
export const ub = "_active_xv4b5_68";
export const navigationStyles = {
  navigation: sb,
  item: ib,
  icon: cb,
  active: ub
};
export const ob = [{
  id: "shop",
  label: "Магазин"
}, {
  id: "arena",
  label: "Арена"
}, {
  id: "king-of-the-hill",
  label: "Царь горы"
}, {
  id: "home",
  label: "Главная"
}, {
  id: "collection",
  label: "Коллекция"
}, {
  id: "profile",
  label: "Профиль"
}];
export function NavigationIcon({
  tab: u
}) {
  return u === "shop" ? jsxRuntime.jsxs("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    children: [jsxRuntime.jsx("path", {
      d: "M3.5 4.5h2l1.8 9.05a1.5 1.5 0 0 0 1.48 1.2h8.75a1.5 1.5 0 0 0 1.43-1.03L21 7.25H7"
    }), jsxRuntime.jsx("path", {
      d: "M9.3 19.1h.01M17.35 19.1h.01"
    })]
  }) : u === "arena" ? jsxRuntime.jsx(IconSwords, {}) : u === "king-of-the-hill" ? jsxRuntime.jsx(IconCrown, { "aria-hidden": "true" }) : u === "home" ? jsxRuntime.jsxs("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    children: [jsxRuntime.jsx("path", {
      d: "m4 10 8-6 8 6v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9Z"
    }), jsxRuntime.jsx("path", {
      d: "M10 20v-5h4v5"
    })]
  }) : u === "collection" ? jsxRuntime.jsxs("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    children: [jsxRuntime.jsx("rect", {
      x: "4",
      y: "3.5",
      width: "16",
      height: "17",
      rx: "2.5"
    }), jsxRuntime.jsx("path", {
      d: "M8 7.5h8M8 11.5h8M8 15.5h4"
    })]
  }) : jsxRuntime.jsxs("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    children: [jsxRuntime.jsx("circle", {
      cx: "12",
      cy: "8",
      r: "3.2"
    }), jsxRuntime.jsx("path", {
      d: "M5.5 20c.7-3.35 3-5.15 6.5-5.15s5.8 1.8 6.5 5.15"
    })]
  });
}
export function AppNavigation({
  activeTab: u,
  onSelect: o
}) {
  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: [jsxRuntime.jsx(HalloweenAccents, { section: "navigation" }), ...ob.map(m => jsxRuntime.jsxs("button", {
      className: u === m.id ? `${navigationStyles.item} ${navigationStyles.active}` : navigationStyles.item,
      onClick: () => o(m.id),
      children: [jsxRuntime.jsx("span", {
        className: navigationStyles.icon,
        children: jsxRuntime.jsx(NavigationIcon, {
          tab: m.id
        })
      }), m.label]
    }, m.id))]
  });
}
